import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Usuario } from '../../models/usuario';
import { SocialAuthService } from "angularx-social-login";
import { GoogleLoginProvider } from "angularx-social-login";
import { JwtHelperService } from '@auth0/angular-jwt';
import { ExternalAuthDto } from '../../models/external-auth-dto';
import { AuthResponseDto } from '../../models/auth-response-dto';
import { TwoFactorDto } from '../../models/two-factor-dto';

@Injectable({
  providedIn: 'root'
})
export class AutenticacionService
{
  private _autenticacionCambioSub = new Subject<boolean>()
  public autenticacionCambio = this._autenticacionCambioSub.asObservable();

  constructor(private http: HttpClient, private _jwtHelper: JwtHelperService, private _externalAuthService: SocialAuthService) { }

  login(userName: string, password: string): Observable<any>
  {
    const clientURI = window.location.origin + '/#/usuario/recover'

    const credenciales = { UserName: userName, Password: password, clienteURI: clientURI};
    return this.http.post(environment.hostService + '/auth/login', credenciales);
  }

  public sendAutenticacionChangeNotification = (isAuthenticated: boolean) =>
  {
    this._autenticacionCambioSub.next(isAuthenticated);
  }

  public signInWithGoogle = () =>
  {
    return this._externalAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }

  public signOutExternal = () =>
  {
    this._externalAuthService.signOut(true);
  }

  public externalLogin = (body: ExternalAuthDto) =>
  {
    return this.http.post<AuthResponseDto>(environment.hostService + '/auth/externallogin', body);
  }

  public twoStepLogin = (body: TwoFactorDto) =>
  {
    return this.http.post<AuthResponseDto>(environment.hostService + '/auth/twostepverification',  body);
  }
}
